import { TextField, TextFieldProps } from '@mui/material';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

type OwnProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
    name: TName;
    control: Control<TFieldValues>;
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & TextFieldProps;

export function FormTextField<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
    name,
    control,
    rules,
    ...props
}: OwnProps<TFieldValues, TName>) {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { value, ...rest }, fieldState: { error } }) => (
                <TextField
                    {...rest}
                    {...props}
                    style={{ whiteSpace: 'nowrap' }}
                    error={!!error}
                    helperText={error?.message}
                    value={value ?? ''}
                    variant="standard"
                />
            )}
        />
    );
}
